// Implements: F-IDN-027
/**
 * Pure helpers of Personas: the search over name and e-mail (case- and accent-blind, as v3 `norm`)
 * and the teams a person sits in, each marked when the person leads it ("· líder").
 */

import type { PersonView, TeamView } from "../../../types/organization";
import { isLead } from "./roles";

export interface PersonTeam {
  readonly id: string;
  readonly name: string;
  readonly lead: boolean;
}

function normalized(text: string): string {
  return text.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
}

export function matchesPerson(person: PersonView, query: string): boolean {
  const wanted = normalized(query.trim());
  if (wanted === "") return true;
  return normalized(`${person.user.full_name} ${person.user.email}`).includes(wanted);
}

export function teamsOfPerson(teams: readonly TeamView[], userId: string): PersonTeam[] {
  return teams.flatMap((team) => {
    const seat = team.members.find((member) => member.user.id === userId);
    return seat === undefined ? [] : [{ id: team.id, name: team.name, lead: isLead(seat.role) }];
  });
}
